// AVAX full report audit 2026-10-08 (F01): a bug-bounty status is a mutable curated record. Every surface that
// prints it states the record date, and a recorded conflicting later observation (backend V330: the component
// evidence carries "EVIDENCE CONFLICT, revalidation pending") is shown beside the status. Owner decision B33 disposed
// of a PAUSED observation: the component is dropped (evidence "PROGRAM PAUSED"). Works on the V328 payload (record
// date from the component evidence).

export interface BountyRecordNote {
  note: string;
  conflict: boolean;
  notScored?: boolean; // B33: a non-active program is not scored (missing, not 0)
  fetched: string | null;
}

export function bountyRecordNote(evidence?: string | null): BountyRecordNote | null {
  if (typeof evidence !== 'string' || !evidence.trim()) return null;
  const m = evidence.match(/fetched (\d{4}-\d{2}-\d{2})/);
  const fetched = m ? m[1] : null;
  // B33 (security_bounty_state_mapping_v2_20261008, backend next): a paused / non-active program is neither ACTIVE
  // nor a confirmed absence; the component is dropped (missing, not 0) and the evidence says so.
  const nonActive = evidence.match(/PROGRAM (PAUSED|SUSPENDED|CLOSED|ENDED)\b/);
  if (nonActive) {
    const obs = evidence.match(/official program page showed (.+?) on (\d{4}-\d{2}-\d{2})/);
    const seen = obs ? `; the official page showed ${obs[1]} on ${obs[2]}` : '';
    return {
      conflict: true,
      notScored: true,
      fetched,
      note: `program ${nonActive[1].toLowerCase()}${seen}: neither active nor a confirmed absence, so the bug-bounty component is not scored (missing, not 0)${fetched ? `; the earlier record was fetched ${fetched}` : ''}`,
    };
  }
  if (/EVIDENCE CONFLICT/.test(evidence)) {
    const obs = evidence.match(/official program page showed (.+?) on (\d{4}-\d{2}-\d{2})/);
    const seen = obs ? `; the official page showed ${obs[1]} on ${obs[2]}` : '';
    return {
      conflict: true,
      fetched,
      note: `evidence conflict, revalidation pending${seen}; the scored status is the curated record${fetched ? ` fetched ${fetched}` : ''}, not a current confirmation`,
    };
  }
  if (!fetched) return null;
  return { conflict: false, fetched, note: `curated record as fetched ${fetched}; a mutable status, confirm against the official program page` };
}
